/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Ios_Step1Inputs */

const cs_pwa_install_ios_step1 = /** @type {(inputs: Pwa_Install_Ios_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V Safari klepněte na Sdílet`)
};

const en_pwa_install_ios_step1 = /** @type {(inputs: Pwa_Install_Ios_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap Share in Safari`)
};

/**
* | output |
* | --- |
* | "Tap Share in Safari" |
*
* @param {Pwa_Install_Ios_Step1Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_ios_step1 = /** @type {((inputs?: Pwa_Install_Ios_Step1Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Ios_Step1Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_ios_step1(inputs)
	return cs_pwa_install_ios_step1(inputs)
});